import { api } from '../context/AuthContext';

const TEAM_ROLES = ['admin', 'kanzlei_mitarbeiter', 'freelancer'];
const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
const safeRef = (ref) => String(ref).replace(/[^a-zA-Z0-9-]/g, '_');

const buildHtml = (timeline, chatRef) => {
  const title = `Chat-Export · Aktenzeichen ${chatRef}`;
  const rows = timeline.map((it) => {
    const when = it.created_at ? new Date(it.created_at).toLocaleString('de-DE') : '';
    if (it._kind === 'evt') {
      return `<tr class="evt"><td>${when}</td><td><strong>STATUS</strong></td><td>${esc(it.author_name)}</td><td><em>${esc(it.text)}</em></td></tr>`;
    }
    const role = TEAM_ROLES.includes(it.author_role) ? 'KANZLEI' : 'MANDANT';
    let body = esc(it.text || '').replace(/\n/g, '<br/>');
    if (it.attachment) body += `<div class="att">Anhang: ${esc(it.attachment.filename)} (${Math.round((it.attachment.size || 0) / 1024)} KB)</div>`;
    return `<tr><td>${when}</td><td><strong>${role}</strong></td><td>${esc(it.author_name)}</td><td>${body}</td></tr>`;
  }).join('\n');
  return `<!doctype html><html lang="de"><head><meta charset="utf-8"><title>${esc(title)}</title>
<style>
body{font-family:Helvetica,Arial,sans-serif;color:#1B3A5C;background:#fff;margin:0;padding:24px;}
h1{font-family:Georgia,serif;font-weight:300;font-size:22px;border-bottom:3px solid #b8893d;padding-bottom:8px;margin:0 0 8px;}
.meta{color:#34536b;font-size:12px;margin-bottom:18px;}
table{border-collapse:collapse;width:100%;font-size:12px;}
th,td{text-align:left;vertical-align:top;padding:8px 10px;border-bottom:1px solid #eef2f7;}
th{background:#f5f8fa;color:#34536b;font-weight:600;letter-spacing:0.05em;font-size:11px;text-transform:uppercase;}
.evt td{background:#fbf7f0;color:#b8893d;}
.att{margin-top:6px;color:#b8893d;font-size:11px;}
.footer{margin-top:24px;color:#7a8a99;font-size:11px;border-top:1px solid #e6ebf0;padding-top:10px;}
@media print { body{padding:0;} h1{page-break-after:avoid;} }
</style></head><body>
<h1>${esc(title)}</h1>
<div class="meta">Exportiert am ${new Date().toLocaleString('de-DE')} · ${timeline.length === 0 ? 'Keine Nachrichten' : timeline.length + ' Einträge'}</div>
<table><thead><tr><th>Zeit</th><th>Rolle</th><th>Absender</th><th>Inhalt</th></tr></thead><tbody>
${rows}
</tbody></table>
<div class="footer">Kanzlei Nabhan Gäbler &amp; Partner · Bundeskanzlerplatz 2D · 53113 Bonn</div>
</body></html>`;
};

const triggerDownload = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
};

export const exportChatHtml = (timeline, chatRef) => {
  const blob = new Blob([buildHtml(timeline, chatRef)], { type: 'text/html;charset=utf-8' });
  triggerDownload(blob, `chat-${safeRef(chatRef)}-${new Date().toISOString().slice(0, 10)}.html`);
};

export const printChat = (timeline, chatRef) => {
  const blob = new Blob([buildHtml(timeline, chatRef)], { type: 'text/html;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const w = window.open(url, '_blank');
  if (!w) { URL.revokeObjectURL(url); return 'Pop-up wurde vom Browser blockiert.'; }
  w.addEventListener('load', () => { try { w.print(); } catch (err) { console.warn('[chatExport] Druckdialog fehlgeschlagen', err); } });
  setTimeout(() => URL.revokeObjectURL(url), 60000);
  return null;
};

export const downloadServerPdf = async (caseId, chatRef) => {
  const resp = await api.get(`/cases/${caseId}/chat.pdf`, { responseType: 'blob' });
  triggerDownload(new Blob([resp.data], { type: 'application/pdf' }), `Chat_${safeRef(chatRef)}.pdf`);
};

export const fetchAttachmentUrl = async (caseId, att) => {
  const resp = await api.get(`/cases/${caseId}/attachments/${att.gridfs_id}`, { responseType: 'blob' });
  return URL.createObjectURL(new Blob([resp.data], { type: att.mime || resp.headers['content-type'] || 'application/octet-stream' }));
};

export const downloadAttachment = async (caseId, att) => {
  const url = await fetchAttachmentUrl(caseId, att);
  const a = document.createElement('a');
  a.href = url; a.download = att.filename || 'anhang';
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
};
